// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-service-buttons[data-v-5704ced8] {\n  background-color: rgb(245, 245, 245);\n  width: 215px;\n  display: inline-block;\n  cursor: pointer;\n}\n.plus-button[data-v-5704ced8] {\n  position: relative;\n  right: 15px;\n  top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
